<template>
  <footer class="d-flex justify-content-center">
    <div class="wrapper d-flex justify-content-center align-items-center">
      <strong> &copy; 2021 BIMBLE</strong>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style>
footer {
  background-color: #fc7901;
}

footer strong {
  font-family: "Poppins", sans-serif;
  font-weight: 800;
  font-style: italic;
  color: white;
}
</style>
